<template functional>
  <div class="relative">
    <a
      v-if="props.options.isImport(props.item)"
      :data-action="'showPickups'"
      :data-order-id="props.item.id"
    >
      <div
        v-for="(str, index) in props.options.splitStr(props.item.depots)"
        :key="index"
        class="cname"
      >
        {{ str }}
      </div>
    </a>
    <div v-else>
      <div
        v-for="(str, index) in props.options.splitStr(props.item.depots)"
        :key="index"
        class="cname"
      >
        {{ str }}
      </div>
    </div>
    <a
      v-if="props.item.equipment_release"
      class="letter equipment-release"
      :data-action="'showEquipmentRelease'"
      :data-order-id="props.item.id"
      :data-turbo-url="`/equipment_releases/new?container_id=${props.item.id}`"
    >
      E
    </a>
  </div>
</template>

<script>
export default {
  name: "drayage-depots",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
.equipment-release {
  @apply bg-slate-100 !size-3.5 !text-xs !leading-3 absolute -right-0.5 top-1/2 -translate-y-1/2;
}
</style>
